import { fromJS } from 'immutable';
import type { AnyAction } from 'redux';

import type { TypedMap } from 'utils/typed-map';

import { INIT, INIT_SUCCESS, INIT_FAILED } from './constants';

export type DonationRulesListPageState = TypedMap<{
  loading: boolean;
  initialized: boolean;
  error: boolean | Error | string;
}>;
export const initialState: DonationRulesListPageState = fromJS({
  loading: false,
  initialized: false,
  error: false,
});

function donationGivingRulesListPageReducer(
  state = initialState,
  action: AnyAction
): DonationRulesListPageState {
  switch (action.type) {
    case INIT:
      return state.merge({ loading: true, initialized: true });

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    default:
      return state;
  }
}

export default donationGivingRulesListPageReducer;
